/**
 * Determines whether the current direction is right-to-left (RTL)
 * based on `document.body.dir` or `document.documentElement.dir` attributes
 */
export function isRtl(): boolean {
  return document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}
